import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../PageSection';
import ImageZoom from '../ImageZoom';

const VideoSection = ({ webm, mp4, videoAlt }) => {
  return (
    <PageSection maxWidth={'md'} spacing={'slim'}>
      <ImageZoom>
        <video autoPlay loop muted playsInline title={videoAlt} style={{ maxWidth: '100%' }}>
          <source src={webm} type="video/webm" />
          <source src={mp4} type="video/mp4" />
        </video>
      </ImageZoom>
    </PageSection>
  );
};

VideoSection.propTypes = {
  webm: PropTypes.string.isRequired,
  mp4: PropTypes.string.isRequired,
  videoAlt: PropTypes.string.isRequired,
};

VideoSection.defaultProps = {};

export default VideoSection;
